import { ChevronLeft, ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";

/** Quantas páginas cabem num total. Zero itens ainda é uma página, a vazia. */
function pageCount(total: number, pageSize: number): number {
  return Math.max(1, Math.ceil(total / pageSize));
}

/**
 * Faixa + Prev/Next, no padrão do catálogo do Functional (`aderencia/CatalogView`).
 * Página começa em 1.
 */
export function CatalogPager({
  page,
  pageSize,
  total,
  onPageChange,
}: {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
}) {
  const { t } = useTranslation();
  const pages = pageCount(total, pageSize);
  const first = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const last = Math.min(page * pageSize, total);

  return (
    <div className="flex flex-wrap items-center justify-end gap-3 text-xs text-muted-foreground">
      <span className="tabular-nums">
        {t("{{first}}–{{last}} of {{total}}", {
          first: first.toLocaleString("en-US"),
          last: last.toLocaleString("en-US"),
          total: total.toLocaleString("en-US"),
        })}
      </span>
      <span className="tabular-nums">
        {t("Page {{page}} of {{pages}}", { page, pages })}
      </span>
      <Button
        size="sm"
        variant="outline"
        className="h-7 gap-1 px-2"
        disabled={page <= 1}
        onClick={() => onPageChange(Math.max(1, page - 1))}
      >
        <ChevronLeft className="h-3.5 w-3.5" /> {t("Prev")}
      </Button>
      <Button
        size="sm"
        variant="outline"
        className="h-7 gap-1 px-2"
        disabled={page >= pages}
        onClick={() => onPageChange(Math.min(pages, page + 1))}
      >
        {t("Next")} <ChevronRight className="h-3.5 w-3.5" />
      </Button>
    </div>
  );
}
